module.exports = __webpack_public_path__ + "img/values.b013cf4b.svg";